import "./dashChit.css";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Dashchit = ({ name, text,data }) => {
  return (
    <div className={name}>
      <div className="chiticon">
        {name === "one" ? (
          <PersonOffIcon></PersonOffIcon>
        ) : name === "two" ? (
          <WarningAmberIcon ></WarningAmberIcon>
        ) : name === "three" ? (
          <MoreTimeIcon ></MoreTimeIcon>
        ) : (
          <DeleteForeverIcon ></DeleteForeverIcon>
        )}
      </div>
      <div className="chitdetaildiv">
        <p className="chitname">{text}</p>
        <h3 className="chitno">{data}</h3>
      </div>
    </div>
  );
};

export default Dashchit;
